import Dispatcher from '../dispatcher';
import { FSRemoveLightBoxActions } from '../constants/fs_remove_light_box/fs_remove_light_box_actions';
import getTranslatedText from '../helper/get_translated_text';

function showAction() {
    Dispatcher.handleFSRemoveLightboxAction({
        type: FSRemoveLightBoxActions.SHOW
    });
}

function hideAction() {
    Dispatcher.handleFSRemoveLightboxAction({
        type: FSRemoveLightBoxActions.HIDE
    });
}

function expandAction() {
    Dispatcher.handleFSRemoveLightboxAction({
        type: FSRemoveLightBoxActions.EXPAND
    });
}

function fsRemoveInvalidAction(invalidMessage) {
    Dispatcher.handleFSRemoveLightboxAction({
        type: FSRemoveLightBoxActions.FS_REMOVE_INVALID_ACTION,
        payload: invalidMessage || getTranslatedText('message-invalid-request'),
    });
}

export {
    showAction,
    hideAction,
    expandAction,
    fsRemoveInvalidAction,
};
